<script setup>
import { tv } from 'tailwind-variants';

/**
 * @typedef {object} PopoverCardContentProps
 * @property {boolean} [isUnstyled=false] - Whether the popover card content is unstyled
 */

/**
 * @type {PopoverCardContentProps}
 */
const props = defineProps({
  isUnstyled: {
    type: Boolean,
    default: false,
  },
});

const popoverCardRecipe = tv({
  base: 'relative isolate w-max',
  variants: {
    isUnstyled: {
      true: '',
      false: 'rounded-xl bg-brand-background',
    },
  },
});
</script>

<template>
  <div
    data-component="CsPopoverCardContent"
    data-slot="content"
    tabindex="-1"
    :class="popoverCardRecipe(props)"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </div>
</template>
